import React, {useEffect, useMemo, useState} from "react";
import { Table, TableHeader, TableBody, TableRow, TableHeaderCell, TableCell, Button, Icon, Input, Checkbox, Select} from "semantic-ui-react";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import DimmerLoader from "../../components/DimmerLoader/DimmerLoader";
import CompetitionsCRUDForm from "./CompetitionsCRUD.form";
import CheckboxCms from "../../components/CheckboxCms/CheckboxCms";
import {useAppDispatch, useAppSelector} from "../../hooks/hooks";
import {
    changePageSize,
    clearSingleCompetition,
    deleteDartsCompetition, getCompetitionInitOptions,
    getDartsCompetitions, getDartsSingleCompetition,
    setEditModeCompetitionForm, setPageNumber,
    showCompetitionForm
} from "./CompetitionsCRUD.slice";
import styles from "./CompetitionsCRUD.module.scss"
import { buildQueryString } from "../../helpers/buildQueryString";
import AppPagination from "../../components/Pagination/AppPagination";

const CompetitionsCRUD = () => {
    const dispatch = useAppDispatch();
    const {dartsCompetitions, isVisibleForm, isLoading, noContent, pagination, clients} = useAppSelector(state => state.CompetitionsCRUD);
    const { cms, permissions } = useAppSelector(state => state.Auth);
    const [searchWord, setSearchWord] = useState("");
    const [client, setClient] = useState<any>(null);
    const [onlyActive, setOnlyActive] = useState(true);

    useEffect(() => {
        dispatch(getDartsCompetitions(buildQueryString({ pageNum: pagination.activePage, pageSize: pagination.pageSize, onlyActive })))
        dispatch(getCompetitionInitOptions())
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const clientOptions = useMemo(() => {
        const allClients = clients.map(client => {
            return {key: client.id, value: client.id, text: client.name}
        })
        allClients.unshift({key: 0, value: 0, text: "All"})
        return allClients
    }, [clients]);

    const openCompetitionForm = () => {
        dispatch(showCompetitionForm());
    }

    const updateCompetitionBtnHandler = (id: number) => {
        dispatch(getDartsSingleCompetition(id));
        dispatch(setEditModeCompetitionForm(id));
        dispatch(clearSingleCompetition());
    }

    const onChangePager = (activePage: string | number | undefined) => {
        dispatch(setPageNumber(activePage))
        const params = { pageNum: activePage, pageSize: pagination.pageSize, search: searchWord}
        dispatch(getDartsCompetitions(buildQueryString(params)));
    }

    const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (searchWord.trim().length < 3) return;
        const params = { search: e.target.value, pageNum: 1, pageSize: pagination.pageSize, onlyActive,clientId:client}
        setSearchWord(e.target.value)
        dispatch(getDartsCompetitions(buildQueryString(params)));
    }

    const onChangeClient = (clientId: any) => {
        const params = { search: searchWord, pageNum: 1, pageSize: pagination.pageSize, clientId, onlyActive}
        setClient(clientId)
        dispatch(getDartsCompetitions(buildQueryString(params)))
    }

    const onClickIsActive = () => {
        setOnlyActive(!onlyActive)
        const params = { search: searchWord, pageNum: pagination.activePage, pageSize: pagination.pageSize, clientId: client, onlyActive: !onlyActive}
        dispatch(getDartsCompetitions(buildQueryString(params)))
    }

    const onChangePageSize = (value: any) => {
        const params = { search: searchWord, pageNum: pagination.activePage, pageSize: value, clientId: client, onlyActive}
        dispatch(getDartsCompetitions(buildQueryString(params)))
        dispatch(changePageSize(value))
    }

    return (
        <div className="cms-container-general">
            <div className={styles.topControls}>
                <div className={styles.filter}>
                    <div>
                        <Input icon='search' placeholder='Search...' value={searchWord} onChange={(e) => onSearch(e)}/>
                    </div>
                    <div>
                        <Checkbox checked={onlyActive} label="only Active" onClick={onClickIsActive}/>
                    </div>
                    {cms['management.clients'] &&
                        <div>
                            <Select value={client} defaultValue={0} placeholder='Select client' options={clientOptions}
                                onChange={(e, {value}) => onChangeClient(value)}/>
                        </div>
                    }
                </div>
                {permissions['create'] &&
                    <Button onClick={openCompetitionForm} id="add_competition" color="green">Add</Button>
                }
            </div>
            {noContent ? (
                <div className="schedule-info-block">No competitions</div>
            ) : (
                    <div className="cms-table-general">
                <Table celled textAlign="center">
                    {isLoading && <DimmerLoader/>}
                    <TableHeader>
                        <TableRow>
                            {permissions['id'] &&
                                <TableHeaderCell>Id</TableHeaderCell>
                            }
                            <TableHeaderCell>Competition name</TableHeaderCell>
                            <TableHeaderCell>Competition type</TableHeaderCell>
                            <TableHeaderCell>A</TableHeaderCell>
                            <TableHeaderCell/>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {dartsCompetitions?.map((competition) => {
                            return (
                                <TableRow key={competition.id}>
                                    {permissions['id'] &&
                                        <TableCell>{competition.id}</TableCell>
                                    }
                                    <TableCell>{competition.name}</TableCell>
                                    <TableCell>{competition.typeName}</TableCell>
                                    <TableCell>
                                        <CheckboxCms value={competition.isActive} isDisabled={true} isReadyOnly={true} />
                                    </TableCell>
                                    <TableCell>
                                        {permissions['id'] &&
                                            <div className={styles.tableControls}>
                                                <DeleteModal id={competition.id!} titleModal={"Delete your Competition"}
                                                    deleteAction={(id: number) => dispatch(deleteDartsCompetition(id))}
                                                    confirmText={"Are you sure you want to delete your competition?"}/>
                                                <Icon name='pencil alternate' link color="grey" size="small"
                                                    onClick={() => updateCompetitionBtnHandler(competition?.id!)}/>
                                            </div>
                                        }
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
                    </div>
            )}
            {isVisibleForm &&
                <CompetitionsCRUDForm
                    clientByFilter={client}
                    search={searchWord}
                    onlyActiveByFilter={onlyActive}
                />
            }
            {!noContent && (
                <AppPagination props={pagination} onChangePager={onChangePager} onChangePageSize={onChangePageSize} />
            )}
        </div>
    );
};

export default CompetitionsCRUD;
